import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import GoogleFilePicker from 'react-google-picker'

import { googlePickerSync } from '../../../../sync'
import config from 'config'
import { normalizeDriveFiles } from 'helpers/pickerNormalizer'
import { getDriveFileTypesAccepted } from 'helpers/pickerFileTypesAcceptedProvider'

class DrivePickerPick extends PureComponent {

	constructor() {
		super()
		this.state = {
			shouldReset: false,
		}
	}

	onChange = data => {
		const token = window.gapi.auth.getToken().access_token
		if (data.action === 'picked') {
			googlePickerSync.getGoogleDriveDownloadLink(data.docs, token).then(function(files) {
				const normalizedFiles = normalizeDriveFiles(files, token)
				this.props.onChange(normalizedFiles)
			}.bind(this))
		}
	}

	onAuthenticate = token => {
		if (!token) {
			this.setState({shouldReset: true})
		}
	}

	resetPicker = () => {
		this.setState({shouldReset: false})
		return null
	}

	render() {
		// scope prop is expected by the library to be an array but Google Drive fails with that.
		// That's why is a string, just a bug in the library. Even there is a warning don't change it.
		return (
			<GoogleFilePicker
				clientId={config.googleDrive.clientId}
				developerKey={config.googleDrive.developerKey}
				scope={'https://www.googleapis.com/auth/drive.readonly'}
				onChange={this.onChange}
				multiselect={this.props.multiselect}
				navHidden={true}
				authImmediate={true}
				mimeTypes={getDriveFileTypesAccepted(this.props.accept)}
				viewId={'DOCS'}
				origin={this.props.googleDrivePickerOrigin}
				onAuthenticate={this.onAuthenticate}
				{...(this.state.shouldReset && {createPicker: this.resetPicker})}
			>
				{this.props.children}
			</GoogleFilePicker>
		)
	}
}

DrivePickerPick.defaultProps = {
	googleDrivePickerOrigin: null,
}

DrivePickerPick.propTypes = {
	googleDrivePickerOrigin: PropTypes.string,
}

export default DrivePickerPick
